import clsx from 'clsx';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../../Translations';
import Button from '../../../../../../../Form/Button';
import Modal from '../../../../../../../Modal';
import ModalStore from '../../../../../../../Modal/Store';
import LearningCollectionEditStore from '../../../../Store';
import { ProductLicenseResource } from '../../../../../../Types';

export interface Props {
  modalStore: ModalStore;
  store: LearningCollectionEditStore;
  newProductLicense: ProductLicenseResource;
}

function WarningModal({ store, modalStore, newProductLicense }: Props) {
  switch (modalStore.state.kind) {
    case 'closed':
      return <></>;
    case 'open':
      return (
        <Modal
          close={modalStore.close}
          title={
            <h3 className="p-4 text-xl font-semibold">
              <T kind="Confirm License Update" />
            </h3>
          }
          customBackgroundCssClasses="bg-teal-100 opacity-60"
        >
          <p className="pb-4">
            <T
              kind="Updating the license will impact the program ..."
              span={(content) => <span className="font-semibold">{content}</span>}
              newLicenseName={newProductLicense.payload.licenseTypePublicName
                .map((name) => name.text)
                .getOrElseValue('new license')}
            />
          </p>
          <p className="pb-4">
            <T kind="Please confirm if you would like to continue." />
          </p>
          <div className="flex justify-end">
            <Button
              type="button"
              value="Cancel"
              className="bg-white text-sm text-teal-600"
              onClick={modalStore.close}
            />
            <Button
              type="button"
              value="Continue"
              className={clsx(
                'ml-4 rounded-md bg-teal-600 px-8 py-2.5 text-sm font-semibold',
                'text-white',
              )}
              onClick={() => {
                store.updateProductLicenseChangeDialog('hide');
                store.selectProductLicense(newProductLicense.payload.id);
                modalStore.close();
              }}
            />
          </div>
        </Modal>
      );
  }
}

export default observer(WarningModal);
